import * as Sentry from '@sentry/react';
import React from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType
} from 'react-router-dom';

export default function initSentry() {
  const SENTRY_ENVIRONMENT = import.meta.env.DEV
    ? 'development'
    : import.meta.env.VITE_SENTRY_ENVIRONMENT;

  Sentry.init({
    enabled: SENTRY_ENVIRONMENT !== 'development',
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: SENTRY_ENVIRONMENT,
    debug: import.meta.env.VITE_SENTRY_DEBUG === 'true',
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect: React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes
      }),
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
      Sentry.browserProfilingIntegration(),
      Sentry.captureConsoleIntegration({
        levels: ['error']
      })
    ],
    // Performance Monitoring
    // TODO: Reduce these values to 0.2 and 0.1 after system goes live
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    profilesSampleRate: 1.0, // Set sampling rate for profiling - this is relative to tracesSampleRate

    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
      'localhost',
      /.*\.visagio\.com/,
      /.*microsoftonline\.com/
    ],
    // Session Replay
    replaysSessionSampleRate: 0.0, // Disable session replay by default
    replaysOnErrorSampleRate: 0.0 // Disable session replay on error by default
  });
}
